import Vue from "vue";

import XIcon from "@/assets/icons/XIcon.vue";
import CameraIconFile from "@/assets/icons/CameraIconFile.vue";
import FileIcon from "@/assets/icons/FileIcon.vue";
import ActionIcon from "@/assets/icons/ActionIcon.vue";
import DeleteModalIcon from "@/assets/icons/DeleteModalIcon.vue";
import RejectedIcon from "@/assets/icons/RejectedIcon.vue";
import ApproveIcon from "@/assets/icons/ApproveIcon.vue";
import ExclamationIcon from "@/assets/icons/ExclamationIcon.vue";
import PendingTagIcon from "@/assets/icons/PendingTagIcon.vue";
import PaperClipIcon from "@/assets/icons/PaperClipIcon.vue";
import DeleteIcon from "@/assets/icons/DeleteIcon.vue";
import DataNotFoundIcon from "@/assets/icons/DataNotFoundIcon.vue";

Vue.component("x-icon", XIcon);
Vue.component("camera-icon", CameraIconFile);
Vue.component("file-icon", FileIcon);
Vue.component("action-icon", ActionIcon);
Vue.component("delete-modal-icon", DeleteModalIcon);
Vue.component("rejected-icon", RejectedIcon);
Vue.component("approve-icon", ApproveIcon);
Vue.component("exclamation-icon", ExclamationIcon);
Vue.component("pending-tag-icon", PendingTagIcon);
Vue.component("paper-clip-icon", PaperClipIcon);
Vue.component("delete-icon", DeleteIcon);
Vue.component("data-not-found-icon", DataNotFoundIcon);